import { useState } from "react";
import { object } from "prop-types";
import { useTranslation } from "react-i18next";
import { Dialog, MenuButton } from "@components";
import { Grid } from "@material-ui/core";
import { BreakdownColumnsList } from "./settings";
import { Settings } from "@assets";

export const SectionColumnSettings = ({
  section
}) => {
  const { t } = useTranslation();
  
  const [ visible, show ] = useState(false);
  
  const handleShowDialog = () => {
    show(!visible);
  };
  
  return (
    <>
      <MenuButton
        icon={ <Settings color="primary" /> }
        onClick={handleShowDialog}
      >
        { t("views.editor.section_columns") }
      </MenuButton>
      {
        visible &&
        <Dialog
          open
          onClose={ handleShowDialog }
          width={ 460 }
          title={ t("views.editor.section_columns_full", {name: section.name}) }
        >
          <Grid item container direction="column">
            <BreakdownColumnsList
              section={section}
            />
          </Grid>
        </Dialog>
      }
    </>
  );
}

SectionColumnSettings.propTypes = {
  section: object.isRequired,
}